function renderSingleFormImportsTemplate({ map }: { map: string }): string {
  return `import {
${map}
} from '@admin/components/ui/card'`
}

function renderSingleFormCardModuleTemplate({
  imports,
  content
}: {
  imports: string
  content: string
}): string {
  return `'use client'
${imports}

${content}
`
}

function renderSingleFormEntryModuleTemplate({
  singular,
  actionImportPath,
  cardImports,
  cardRenders
}: {
  singular: string
  actionImportPath: string
  cardImports: string
  cardRenders: string
}): string {
  return `import type { ${singular} } from '@admin/actions/${actionImportPath}'
${cardImports}

interface ${singular}FormProps {
  initialData?: ${singular} | null
}

export function ${singular}Form({ initialData }: ${singular}FormProps) {
  return (
    <div className="space-y-6">
${cardRenders}
    </div>
  )
}
`
}

export function renderSingleFormRenderer(
  request:
    | { kind: 'renderSingleFormImportsTemplate'; props: { map: string } }
    | {
        kind: 'renderSingleFormCardModuleTemplate'
        props: {
          imports: string
          content: string
        }
      }
    | {
        kind: 'renderSingleFormEntryModuleTemplate'
        props: {
          singular: string
          actionImportPath: string
          cardImports: string
          cardRenders: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderSingleFormImportsTemplate':
      return renderSingleFormImportsTemplate(request.props)
    case 'renderSingleFormCardModuleTemplate':
      return renderSingleFormCardModuleTemplate(request.props)
    case 'renderSingleFormEntryModuleTemplate':
      return renderSingleFormEntryModuleTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
